import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { darken, lighten } from 'polished'
import { BaseButton } from './baseButton'

const Button = styled(BaseButton)`
    box-sizing: border-box;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    width: min-content;
    height: min-content;

    &:hover {
        background-color: ${(p) => p.theme.colors.primaryGrey};
    }

    &:active {
        background-color: ${(p) => darken(0.1, p.theme.colors.primaryGrey)};
    }
`

interface Props {
    onClick?: () => void
    children: ReactNode
}

export const IconButton: FC<Props> = ({ children, onClick }) => {
    return <Button onClick={onClick}>{children}</Button>
}
